export function normalizeHistoryDisplayDays(value: unknown): number {
  const days = Number(value);
  return Number.isSafeInteger(days) && days > 0 ? days : 0;
}
